var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19507 2.99547C2.19507 2.55073 2.55308 2.19531 2.98843 2.19531L8.23791 2.19531C8.67326 2.19531 9.03127 2.55074 9.03127 2.99547V4.7189H6.76192C5.63059 4.7189 4.71856 5.6396 4.71856 6.76905V9.03151H2.98843C2.55308 9.03151 2.19507 8.67609 2.19507 8.23136L2.19507 2.99547ZM4.71856 10.2815H2.98843C1.8571 10.2815 0.945068 9.36081 0.945068 8.23136L0.945068 2.99547C0.945068 1.86602 1.8571 0.945313 2.98843 0.945313L8.23791 0.945313C9.36924 0.945313 10.2813 1.86602 10.2813 2.99547V4.7189H12.0114C13.1427 4.7189 14.0548 5.6396 14.0548 6.76905L14.0548 12.0049C14.0548 13.1344 13.1427 14.0551 12.0114 14.0551L6.76192 14.0551C5.63059 14.0551 4.71856 13.1344 4.71856 12.0049V10.2815ZM10.2813 5.9689L12.0114 5.9689C12.4468 5.9689 12.8048 6.32432 12.8048 6.76905L12.8048 12.0049C12.8048 12.4497 12.4468 12.8051 12.0114 12.8051L6.76192 12.8051C6.32657 12.8051 5.96856 12.4497 5.96856 12.0049L5.96856 10.2815L8.23791 10.2815C9.36924 10.2815 10.2813 9.36081 10.2813 8.23136L10.2813 5.9689ZM9.03127 5.9689L9.03127 8.23136C9.03127 8.67609 8.67326 9.03151 8.23791 9.03151L5.96856 9.03151V6.76905C5.96856 6.32432 6.32657 5.9689 6.76192 5.9689H9.03127Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGrey);
export default __webpack_public_path__ + "static/media/copy-grey.314d9eec64ca44c173560985de2cce7d.svg";
export { ForwardRef as ReactComponent };